module.exports = __webpack_public_path__ + "assets/discover.ac52cd46f89fa40a29a0bfb954e33173.svg";